module.exports = __webpack_public_path__ + "static/media/Kobrasol.ec267286.png";